import React, { useEffect, useState } from 'react'
import { StyleSheet, Text, TextInput, View } from 'react-native'
import Show from '@components/Show'
import { colors } from '@lib/colors'

enum InputStatus {
  idle = 0,
  active,
  error,
}

interface InputProps {
  value?: string
  error?: string
  hidden?: boolean
  placeholder?: string
  autoCapitalize?: 'none' | 'sentences' | 'words' | 'characters'
  onChange?: (value: string) => void
}

export default function (props: InputProps) {
  const {
    autoCapitalize = 'none',
    value = '',
    placeholder,
    hidden = false,
    error,
    onChange = () => {},
  } = props

  const [inputStatus, setInputStatus] = useState<InputStatus>(InputStatus.idle)

  useEffect(() => {
    if (error) setInputStatus(InputStatus.error)
  }, [error])

  const getPlaceholder = () => {
    return placeholder || 'Select a value...'
  }

  const inputBackgroundColor = (() => {
    return value ? colors.white : colors.gray[50]
  })()

  const labelColor = (() => {
    if (inputStatus === InputStatus.error) return colors.red[400]
    if (inputStatus === InputStatus.active) return colors.blue[400]
    return colors.gray[400]
  })()

  const borderColor = (() => {
    if (inputStatus === InputStatus.error) return colors.red[200]
    if (inputStatus === InputStatus.active) return colors.blue[200]
    if (value === '') return colors.gray[50]
    return colors.gray[100]
  })()

  return (
    <View style={ styles.wrapper }>
      <View style={ { ...styles.borderBase, backgroundColor: borderColor } }>
        <TextInput
          onFocus={() => {
            setInputStatus(InputStatus.active)
          }}
          onBlur={() => {
            setInputStatus(InputStatus.idle)
          }}
          autoCapitalize={ autoCapitalize }
          secureTextEntry={ hidden }
          placeholder={ getPlaceholder() }
          placeholderTextColor={ colors.gray[300] }
          value={ value || undefined }
          style={ { ...styles.inputBase, backgroundColor: inputBackgroundColor } }
          onChangeText={ onChange }
        />
      </View>

      <Show when={placeholder && !!value}>
        <Text style={ { ...styles.labelBase, color: labelColor } }>{ placeholder }</Text>
      </Show>

      <Show when={error}>
        <Text style={ styles.errorMessage }>{ error }</Text>
      </Show>
    </View>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    position: 'relative',
    width: '100%',
  },
  labelBase: {
    position: 'absolute',
    left: 12,
    top: 8,
    backgroundColor: colors.white,
    paddingLeft: 2,
    paddingRight: 2,
    fontSize: 12,
    fontWeight: '600',
  },
  borderBase: {
    padding: 2,
    marginTop: 15,
    borderRadius: 6,
  },
  inputBase: {
    borderRadius: 4,
    padding: 12,
  },
  errorMessage: {
    color: colors.red[400],
    marginLeft: 12,
    marginTop: 3,
  },
})
